import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
  Welcome to Hexcodeblogs
    </Text>
    <p>{`We are `}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://hexcodelabs.lk/"
        }}>{`HEXCODELABS`}</a></strong>{` and this is how we envision the future!!! Our blog, is your technical guide to the latest innovations and technologies used at Hexcodelabs ranging from customized websites to robotics development and IoT solutions. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      